import ProductAttributes from "../components/modals/common/productAttributes.vue";
import SelectMenu from "../components/modals/common/selectMenu.vue";

const ProductAttributesModalPlugin = {
  // every plugin for Vue.js needs install method
  // this method will run after Vue.use(<your-plugin-here>) is executed
  install(Vue, options) {
    // We must create new Eventbus which is just another Vue instance that will be listening for and emitting events
    // from our main instance this EventBus will be available as ProductAttributesModalPlugin.EventBus
    this.EventBus = new Vue();

    // making our modal component global and add <product-attributes-modal /> in App.vue
    Vue.component("product-attributes-modal", ProductAttributes);

    // exposing global $productAttributesModal object with method show(); method show() takes object params as argument
    // inside this object we can have modal params, styles... and also callback confirm function
    Vue.prototype.$productAttributesModal = {
      show(params) {
        // if we use this.$productAttributesModal.show(params) inside our original Vue instance
        // we will emit 'show' event with parameters 'params' on eventbus of this plugin
        ProductAttributesModalPlugin.EventBus.$emit("show", params);
      },
      hide() {
        ProductAttributesModalPlugin.EventBus.$emit("hide");
      }
    };
  }
};

const SelectMenuModalPlugin = {
  install(Vue, options) {
    this.EventBus = new Vue();
    Vue.component("select-menu-modal", SelectMenu);
    Vue.prototype.$selectMenuModal = {
      show(params) {
        SelectMenuModalPlugin.EventBus.$emit("show", params);
      },
      hide() {
        SelectMenuModalPlugin.EventBus.$emit("hide");
      }
    };
  }
};

export { ProductAttributesModalPlugin, SelectMenuModalPlugin };
